<template>
    <div class="p-grid">
        <div class="p-col-12" v-if="this.notNullOrEmptyObject(this.rules)">
            <div class="card" v-for="(rule, index) in rules" :key="'rule' + index">
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ 'Draw ' + rule.draws[0].offerNumber + ' . Date: ' + formatDate(rule.draws[0].date) }}</label>
                </div>
                <div class="p-field p-grid">
                    <label for="sportName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.crtTicketsNo') }}</label>
                    <label for="sportName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ rule.crtTicketsNo }}</label>
                </div>
                <div class="p-field p-grid">
                    <label for="displayName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.crtTicketsAmount') }}</label>
                    <label for="displayName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ rule.crtTicketsAmount }}</label>
                </div>
            </div>
        </div>
        <div v-else class="p-col-12">
            <div class="card">
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-12 p-md-2 p-mb-md-0">{{ $t('lotto.rules.noTicketsForRule') }}</label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { LottoApi } from '../../../service/LottoApi';
export default {
    data() {
        return {
            LottoApi: new LottoApi(),
            crtTicketsNo: 0,
            crtTicketsAmount: 0,
            rules: [],
        };
    },
    props: {
        rule: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ruleObj() {
            return { ...this.rule };
        },
    },
    mounted() {
        this.LottoApi.getRuleCrtValues(this.ruleObj._id)
            .then(response => {
                this.rules = response.data;
                console.log(this.rules);
            })
            .catch(() => {});
    },
};
</script>
